import React from "react";

import { FaFacebook, FaGithub, FaDribbble, FaTwitter } from "react-icons/fa";

import Rating from "../../components/common/Rating";
import { Link } from "react-router-dom";
import { footerPrimaryPages, footerPages, footerTemplate } from "../../data";
import { useLanguage } from "../../context/LanguageContext";

const Footer = ({ footerLight, style, footerGradient }) => {
  const { t, language } = useLanguage();

  return (
    <>
      <footer className="footer-section">
        <div
          className={`footer-top ptb-120 ${
            footerLight ? "footer-light" : "bg-dark"
          } ${footerGradient ? "bg-gradient" : ""}  text-white`}
          style={style}
        >
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-md-8 col-lg-4 mb-md-4 mb-lg-0">
                <div className="footer-single-col">
                  <div className="footer-single-col mb-4">
                    {footerLight ? (
                      <img src="assets/img/logo-color.png" alt="logo" />
                    ) : (
                      <img src="assets/img/logo-white.png" alt="logo" />
                    )}
                  </div>
                  <p>
                    {t('footer.newsletter.title')}
                  </p>

                  <form className="newsletter-form position-relative d-block d-lg-flex d-md-flex">
                    <input
                      type="text"
                      className="input-newsletter form-control me-2"
                      placeholder={t('footer.newsletter.placeholder')}
                      name="email"
                      required
                      autoComplete="off"
                    />
                    <input
                      type="submit"
                      value={t('footer.newsletter.button')}
                      data-wait="Please wait..."
                      className="btn btn-primary mt-3 mt-lg-0 mt-md-0"
                    />
                  </form>
                  <div className="ratting-wrap mt-4">
                    <h6 className="mb-0">{t('footer.rating.title')}</h6>
                    <Rating />
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-7 mt-4 mt-md-0 mt-lg-0">
                <div className="row">
                  <div className="col-md-6 col-lg-6 mt-4 mt-md-0 mt-lg-0">
                    <div className="footer-single-col">
                      <h3>{t('footer.sections.primary.title')}</h3>
                      <ul className="list-unstyled footer-nav-list mb-lg-0">
                        {footerPrimaryPages.map((primaryPage, i) => (
                          <li key={i + 1}>
                            <Link
                              className="text-decoration-none"
                              to={primaryPage.href}
                            >
                              {primaryPage.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6 mt-4 mt-md-0 mt-lg-0">
                    <div className="footer-single-col">
                      <h3>{t('footer.sections.pages.title')}</h3>
                      <ul className="list-unstyled footer-nav-list mb-lg-0">
                        {footerPages.map((page, i) => (
                          <li key={i + 1}>
                            <Link
                              className="text-decoration-none"
                              to={page.href}
                            >
                              {page.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`footer-bottom ${
            footerLight ? "footer-light" : "bg-dark"
          } ${footerGradient ? "bg-gradient" : ""} text-white py-4`}
        >
          <div className="container">
            <div className="row justify-content-between align-items-center">
              <div className="col-md-7 col-lg-7">
                <div className="copyright-text">
                  <p className="mb-lg-0 mb-md-0">
                    {t('footer.copyright')}
                  </p>
                </div>
              </div>
              <div className="col-md-4 col-lg-4">
                <div className="footer-single-col text-start text-lg-end text-md-end">
                  <ul className="list-unstyled list-inline footer-social-list mb-0">
                    <li className="list-inline-item">
                      <Link href="#">
                        <FaFacebook />
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link href="#">
                        <FaTwitter />
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link href="#">
                        <FaDribbble />
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link href="#">
                        <FaGithub />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
